const columns = gsap.utils.toArray(".column");
window.addEventListener("load", () => {
  columns.forEach((column, i) => {
    const items = gsap.utils.toArray(".item", column);
    verticalLoop(items, {
      repeat: -1,
      paddingBottom: 10,
      reversed: i % 2 > 0 ? true : false
    });
  });
});
function verticalLoop(items, config) {
  let timeline;
  items = gsap.utils.toArray(items);
  config = config || {};
  gsap.context(() => {
    let onChange = config.onChange,
      lastIndex = 0,
      tl = gsap.timeline({
        repeat: config.repeat,
        onUpdate: onChange && function () {
          let i = tl.closestIndex();
          if (lastIndex !== i) {
            lastIndex = i;
            onChange(items[i], i);
          }
        },
        paused: config.paused,
        defaults: {
          ease: "none"
        },
        onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
      }),
      length = items.length,
      startY = items[0].offsetTop,
      times = [],
      heights = [],
      spaceBefore = [],
      yPercents = [],
      curIndex = 0,
      center = config.center,
      clone = obj => {
        let result = {},
          p;
        for (p in obj) {
          result[p] = obj[p];
        }
        return result;
      },
      pixelsPerSecond = (config.speed || 1) * 30,
      snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1),
      // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
      timeOffset = 0,
      container = center === true ? items[0].parentNode : gsap.utils.toArray(center)[0] || items[0].parentNode,
      totalHeight,
      getTotalHeight = () => items[length - 1].offsetTop + yPercents[length - 1] / 100 * heights[length - 1] - startY + spaceBefore[0] + items[length - 1].offsetHeight * gsap.getProperty(items[length - 1], "scaleY") + (parseFloat(config.paddingBottom) || 0),
      populateHeights = () => {
        let b1 = container.getBoundingClientRect(),
          b2;
        startY = items[0].offsetTop;
        items.forEach((el, i) => {
          heights[i] = parseFloat(gsap.getProperty(el, "height", "px"));
          yPercents[i] = snap(parseFloat(gsap.getProperty(el, "y", "px")) / heights[i] * 100 + gsap.getProperty(el, "yPercent"));
          b2 = el.getBoundingClientRect();
          spaceBefore[i] = b2.top - (i ? b1.bottom : b1.top);
          b1 = b2;
        });
        gsap.set(items, {
          // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
          yPercent: i => yPercents[i]
        });
        totalHeight = getTotalHeight();
      },
      timeWrap,
      populateOffsets = () => {
        timeOffset = center ? tl.duration() * (container.offsetWidth / 2) / totalHeight : 0;
        center && times.forEach((t, i) => {
          times[i] = timeWrap(tl.labels["label" + i] + tl.duration() * heights[i] / 2 / totalHeight - timeOffset);
        });
      },
      getClosest = (values, value, wrap) => {
        let i = values.length,
          closest = 1e10,
          index = 0,
          d;
        while (i--) {
          d = Math.abs(values[i] - value);
          if (d > wrap / 2) {
            d = wrap - d;
          }
          if (d < closest) {
            closest = d;
            index = i;
          }
        }
        return index;
      },
      populateTimeline = () => {
        let i, item, curY, distanceToStart, distanceToLoop;
        tl.clear();
        for (i = 0; i < length; i++) {
          item = items[i];
          curY = yPercents[i] / 100 * heights[i];
          distanceToStart = item.offsetTop + curY - startY + spaceBefore[0];
          distanceToLoop = distanceToStart + heights[i] * gsap.getProperty(item, "scaleY");
          tl.to(item, {
            yPercent: snap((curY - distanceToLoop) / heights[i] * 100),
            duration: distanceToLoop / pixelsPerSecond
          }, 0).fromTo(item, {
            yPercent: snap((curY - distanceToLoop + totalHeight) / heights[i] * 100)
          }, {
            yPercent: yPercents[i],
            duration: (curY - distanceToLoop + totalHeight - curY) / pixelsPerSecond,
            immediateRender: false
          }, distanceToLoop / pixelsPerSecond).add("label" + i, distanceToStart / pixelsPerSecond);
          times[i] = distanceToStart / pixelsPerSecond;
        }
        timeWrap = gsap.utils.wrap(0, tl.duration());
      },
      customAnimations = () => {
        let {
            enterAnimation,
            leaveAnimation
          } = config,
          eachDuration = tl.duration() / items.length;
        items.forEach((item, i) => {
          let anim = enterAnimation && enterAnimation(item, eachDuration, i),
            isAtEnd = anim && tl.duration() - timeWrap(times[i] - Math.min(eachDuration, anim.duration())) < eachDuration - 0.05;
          anim && tl.add(anim, isAtEnd ? 0 : timeWrap(times[i] - anim.duration()));
          anim = leaveAnimation && leaveAnimation(item, eachDuration, i);
          isAtEnd = times[i] === tl.duration();
          anim && anim.duration() > eachDuration && anim.duration(eachDuration);
          anim && tl.add(anim, isAtEnd ? 0 : times[i]);
        });
      },
      refresh = deep => {
        let progress = tl.progress();
        tl.progress(0, true);
        populateHeights();
        deep && populateTimeline();
        populateOffsets();
        customAnimations();
        deep && tl.draggable ? tl.time(times[curIndex], true) : tl.progress(progress, true);
      },
      onResize = () => refresh(true),
      proxy;
    gsap.set(items, {
      y: 0
    });
    populateHeights();
    populateTimeline();
    populateOffsets();
    customAnimations();
    window.addEventListener("resize", onResize);
    function toIndex(index, vars) {
      vars = clone(vars);
      Math.abs(index - curIndex) > length / 2 && (index += index > curIndex ? -length : length); // always go in the shortest direction
      let newIndex = gsap.utils.wrap(0, length, index),
        time = times[newIndex];
      if (time > tl.time() !== index > curIndex) {
        // if we're wrapping the timeline's playhead, make the proper adjustments
        time += tl.duration() * (index > curIndex ? 1 : -1);
      }
      if (vars.revolutions) {
        time += tl.duration() * Math.round(vars.revolutions);
        delete vars.revolutions;
      }
      if (time < 0 || time > tl.duration()) {
        vars.modifiers = {
          time: timeWrap
        };
      }
      curIndex = newIndex;
      vars.overwrite = true;
      gsap.killTweensOf(proxy);
      return tl.tweenTo(time, vars);
    }
    tl.elements = items;
    tl.next = vars => toIndex(curIndex + 1, vars);
    tl.previous = vars => toIndex(curIndex - 1, vars);
    tl.current = () => curIndex;
    tl.toIndex = (index, vars) => toIndex(index, vars);
    tl.closestIndex = setCurrent => {
      let index = getClosest(times, tl.time(), tl.duration());
      setCurrent && (curIndex = index);
      return index;
    };
    tl.times = times;
    tl.progress(1, true).progress(0, true); // pre-render for performance
    if (config.reversed) {
      tl.vars.onReverseComplete();
      tl.reverse();
    }
    if (config.draggable && typeof Draggable === "function") {
      proxy = document.createElement("div");
      let wrap = gsap.utils.wrap(0, 1),
        ratio,
        startProgress,
        draggable,
        dragSnap,
        align = () => tl.progress(wrap(startProgress + (draggable.startY - draggable.y) * ratio)),
        syncIndex = () => tl.closestIndex(true);
      typeof InertiaPlugin === "undefined" && console.warn("InertiaPlugin required for momentum-based scrolling and snapping. https://gsap.com/pricing");
      draggable = Draggable.create(proxy, {
        trigger: items[0].parentNode,
        type: "y",
        onPressInit() {
          gsap.killTweensOf(tl);
          startProgress = tl.progress();
          refresh();
          ratio = 1 / totalHeight;
          gsap.set(proxy, {
            y: startProgress / -ratio
          });
        },
        onDrag: align,
        onThrowUpdate: align,
        inertia: true,
        snap: value => {
          let time = -(value * ratio) * tl.duration(),
            wrappedTime = timeWrap(time),
            snapTime = times[getClosest(times, wrappedTime, tl.duration())],
            dif = snapTime - wrappedTime;
          Math.abs(dif) > tl.duration() / 2 && (dif += dif < 0 ? tl.duration() : -tl.duration());
          return (time + dif) / tl.duration() / -ratio;
        },
        onRelease: syncIndex,
        onThrowComplete: syncIndex
      })[0];
      tl.draggable = draggable;
    }
    tl.closestIndex(true);
    onChange && onChange(items[curIndex], curIndex);
    timeline = tl;
    return () => window.removeEventListener("resize", onResize); // cleanup
  });

  return timeline;
}

//------------------------------- banner crousel ends here ///

gsap.registerPlugin(ScrollTrigger);
function marqueeScroll(selector, direction = -1) {
  const track = document.querySelector(selector + " .marquee-track");
  gsap.to(track, {
    xPercent: direction * 50,
    ease: "none",
    scrollTrigger: {
      trigger: selector,
      start: "top bottom",
      end: "bottom top",
      scrub: true
    },
    modifiers: {
      xPercent: gsap.utils.wrap(-50, 0)
    }
  });
}

// Top â†’ left
marqueeScroll(".marquee-carousel-1", -1);
// Bottom â†’ right
marqueeScroll(".marquee-carousel-2", 1);

//------------------------------- section 2 on scroll move left to right  ends here ///

//------------------------------- section compare university strat from here  ///

// const universities = {
//     iit: {
//         name: "IIT Delhi",
//         logo: "assets/images/university-img/campus-01.webp",
//         ranking: 2,
//         fees: 250000,
//         placement: 2500000,
//         established: 1961,
//         campus: "Urban",
//         hostel: "Yes",
//         accreditation: "AICTE, UGC",
//         courses: ["B.Tech", "M.Tech", "PhD"]
//     },
//     nit: {
//         name: "NIT Trichy",
//         logo: "assets/images/university-img/campus-02.webp",
//         ranking: 8,
//         fees: 180000,
//         placement: 1200000,
//         established: 1964,
//         campus: "Residential",
//         hostel: "Yes",
//         accreditation: "AICTE, UGC",
//         courses: ["B.Tech", "M.Tech", "MBA"]
//     },
//     du: {
//         name: "Delhi University",
//         logo: "assets/images/university-img/campus-03.webp",
//         ranking: 11,
//         fees: 80000,
//         placement: 800000,
//         established: 1922,
//         campus: "Urban",
//         hostel: "Limited",
//         accreditation: "UGC, NAAC A+",
//         courses: ["BA", "BSc", "MA", "MSc"]
//     }
// };

// /* ===== Populate Selects ===== */
// const uniOne = document.getElementById("uniOne");
// const uniTwo = document.getElementById("uniTwo");

// Object.keys(universities).forEach(key => {
//     uniOne.add(new Option(universities[key].name, key));
//     uniTwo.add(new Option(universities[key].name, key));
// });

// /* ===== Swap ===== */
// document.getElementById("swapBtn").onclick = () => {
//     [uniOne.value, uniTwo.value] = [uniTwo.value, uniOne.value];
//     document.getElementById("compareBtn").click();
// };

// /* ===== Compare ===== */
// document.getElementById("compareBtn").onclick = () => {
//     if (!uniOne.value || !uniTwo.value || uniOne.value === uniTwo.value) {
//         alert("Please select two different universities.");
//         return;
//     }

//     const u1 = universities[uniOne.value];
//     const u2 = universities[uniTwo.value];

//     const better = (a, b, reverse = false) =>
//         reverse ? (a < b ? "good" : "bad") : (a > b ? "good" : "bad");

//     cardOne.innerHTML = `
//         <div class="table-card">
//             <div class="table-header">
//                 <img src="${u1.logo}">
//                 <h3>${u1.name}</h3>
//                 <span class="rank">#${u1.ranking}</span>
//             </div>

//             <div class="table-row ${better(u1.ranking, u2.ranking, true)}">
//                 <span>Ranking</span><strong>${u1.ranking}</strong>
//             </div>

//             <div class="table-row ${better(u2.fees, u1.fees)}">
//                 <span>Fees</span><strong>â‚¹${u1.fees.toLocaleString()}</strong>
//             </div>

//             <div class="table-row ${better(u1.placement, u2.placement)}">
//                 <span>Placement</span><strong>â‚¹${u1.placement.toLocaleString()}</strong>
//             </div>

//             <div class="table-row">
//                 <span>Courses</span><strong>${u1.courses.join(", ")}</strong>
//             </div>

//             <div class="table-row">
//                 <span>Campus</span><strong>${u1.campus}</strong>
//             </div>

//             <div class="table-row">
//                 <span>Hostel</span><strong>${u1.hostel}</strong>
//             </div>

//             <div class="table-row">
//                 <span>Established</span><strong>${u1.established}</strong>
//             </div>

//             <div class="table-row">
//                 <span>Accreditation</span><strong>${u1.accreditation}</strong>
//             </div>
//         </div>
//     `;

//     cardTwo.innerHTML = `
//         <div class="table-card">
//             <div class="table-header">
//                 <img src="${u2.logo}">
//                 <h3>${u2.name}</h3>
//                 <span class="rank">#${u2.ranking}</span>
//             </div>

//             <div class="table-row ${better(u2.ranking, u1.ranking, true)}">
//                 <span>Ranking</span><strong>${u2.ranking}</strong>
//             </div>

//             <div class="table-row ${better(u1.fees, u2.fees)}">
//                 <span>Fees</span><strong>â‚¹${u2.fees.toLocaleString()}</strong>
//             </div>

//             <div class="table-row ${better(u2.placement, u1.placement)}">
//                 <span>Placement</span><strong>â‚¹${u2.placement.toLocaleString()}</strong>
//             </div>

//             <div class="table-row">
//                 <span>Courses</span><strong>${u2.courses.join(", ")}</strong>
//             </div>

//             <div class="table-row">
//                 <span>Campus</span><strong>${u2.campus}</strong>
//             </div>

//             <div class="table-row">
//                 <span>Hostel</span><strong>${u2.hostel}</strong>
//             </div>

//             <div class="table-row">
//                 <span>Established</span><strong>${u2.established}</strong>
//             </div>

//             <div class="table-row">
//                 <span>Accreditation</span><strong>${u2.accreditation}</strong>
//             </div>
//         </div>
//     `;

//     gsap.fromTo(".compare-result",
//         { opacity: 0 },
//         { opacity: 1, duration: 0.3 }
//     );

//     gsap.from(".table-row", {
//         opacity: 0,
//         x: -20,
//         duration: 0.45,
//         stagger: 0.05,
//         ease: "power2.out"
//     });
// };

// /* ===== DEFAULT COMPARE ON LOAD ===== */
// window.addEventListener("DOMContentLoaded", () => {
//     uniOne.value = "iit";
//     uniTwo.value = "nit";
//     document.getElementById("compareBtn").click();
// });

//------------------------------- section compare university ends here  ///

gsap.registerPlugin(ScrollTrigger);
let horizontalSection = document.querySelector('.horizontal');
console.log(horizontalSection.scrollWidth);
gsap.to('.horizontal', {
  x: () => horizontalSection.scrollWidth * -1,
  xPercent: 100,
  scrollTrigger: {
    trigger: '.horizontal',
    start: 'center center',
    end: '+=2000px',
    pin: '#horizontal-scoll',
    scrub: true,
    invalidateOnRefresh: true
  }
});
gsap.from(".uni-info .row", {
  opacity: 0,
  y: 20,
  duration: 0.5,
  stagger: 0.15,
  scrollTrigger: {
    trigger: ".uni-info",
    start: "top 80%"
  }
});
gsap.from(".btn-download", {
  opacity: 0,
  scale: 0.9,
  duration: 0.4,
  delay: 0.4,
  scrollTrigger: {
    trigger: ".uni-info",
    start: "top 80%"
  }
});